import { render, staticRenderFns } from "./EventDetailNew.vue?vue&type=template&id=0b50ed05&"
import script from "./EventDetailNew.vue?vue&type=script&lang=js&"
export * from "./EventDetailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports